import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class SnEvidenceCategory extends SnModel {
  @Expose()
  public name: string;

  constructor(data?: any) {
    super();
    this.fromJSON(data);
  }
}
